import { Typography } from 'antd';
import { useMemo, useRef } from 'react';

import { TimeLine } from '@app//components/Calendars/components/TimeLine';
import {
  CD_FULL_DAY_HEIGHT,
  CD_PREFIX,
} from '@app/components/Calendars/components/Dashboard/constants';
import type { DashboardType } from '@app/components/Calendars/components/Dashboard/types';
import { TimeColumn } from '@app/components/Calendars/components/TimeColumn';
import { TimeSidebar } from '@app/components/Calendars/components/TimeSidebar';
import { LoadingBox } from '@app/components/LoadingBox';
import { useResize } from '@app/hooks';
import { generateTimes } from '@app/utils';

import '@app/components/Calendars/components/Dashboard/styles/Dashboard.desktop.scss';

const { Text } = Typography;

export const Dashboard: DashboardType = ({
  columns = [],
  createTaskForRange,
  openPreviewTaskModal,
  isLoading,
}) => {
  const times = useMemo(generateTimes, []);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { width } = useResize(containerRef);
  const columnWidth = useMemo(
    () => (width - 64 - 42) / columns.length,
    [width, columns.length]
  );
  return (
    <div className={`${CD_PREFIX}-container`} ref={containerRef}>
      <LoadingBox isLoading={isLoading} />
      <div className={`${CD_PREFIX}-time-sidebar-container`}>
        <div style={{ height: CD_FULL_DAY_HEIGHT }}>
          <Text className="gray-color">Весь день</Text>
        </div>
        <TimeSidebar
          times={times}
          className={`${CD_PREFIX}-time-sidebar gray-color`}
        />
        <TimeLine
          startOfDay={times[0]}
          headerHeight={CD_FULL_DAY_HEIGHT}
          className="calendar-timeline"
        />
      </div>
      <div className={`${CD_PREFIX}-columns`}>
        {columns.map((tasks) => {
          const { day: taskDay } = tasks;
          return (
            <TimeColumn
              key={`${taskDay?.year}-${taskDay?.month}-${taskDay?.day}`}
              times={times}
              tasks={tasks}
              createTaskForRange={createTaskForRange}
              openPreviewTaskModal={openPreviewTaskModal}
              width={columnWidth}
            />
          );
        })}
      </div>
      <div className="right-space" />
    </div>
  );
};
